import React from 'react';

import Icon from './Icon';

const ChevronDown = ({ className }) => (
  <Icon
    name="chevron-down"
    className={className}
    viewBox="0 0 24 24"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="1.414"
  >
    <path
      d="M21.707 9.797L12 19.504 2.293 9.797l1.414-1.414L12 16.676l8.293-8.293 1.414 1.414z"
      fillRule="nonzero"
    />
  </Icon>
);

export default ChevronDown;
